<template>
  <div class="qrcode-box">
    <img v-if="scanUrl" :src="scanUrl" alt="" />
    <div v-if="expired || scanned" class="qrcode-info_mask"></div>
    <div v-if="expired || scanned" class="qrcode-info_wrap">
      <div class="qrcode-info">
        <div v-if="expired" class="qrcode-info_label">当前二维码已过期</div>
        <div v-else-if="scanned" class="qrcode-info_label">
          已扫描，请在手机上确认
        </div>
        <a href="javascript:;" @click="getCode" class="qrcode-info_btn">刷新</a>
      </div>
    </div>
  </div>
</template>

<script>
import { subscribe, disconnect } from "@/api/socket";

export default {
  data() {
    return {
      code: null,
      scanUrl: null,
      expireTime: null,
      expired: false,
      scanned: false,
    };
  },
  mounted() {
    this.getCode();
  },
  beforeDestroy() {
    this.clearRefreshTask();
  },
  methods: {
    getCode() {
      const me = this;
      this.$ajax({
        url: this.$url.api + "/api/auth/qrcode/create",
      }).then(function (res) {
        if (res.data.success) {
          me.expireTime = Date.now() + 300000;
          me.expired = false;
          me.scanned = false;
          me.code = res.data.data;
          me.getQrcodeImage(me.code);
          me.addRefreshTask();
          subscribe(me.code, "/qrcode/login", {
            // 用于识别连接的socket服务器
            Authorization: me.code
          }, (msg) => {
            if (msg.type == "scanned") {
              me.scanned = true;
            } else {
              me.refreshAuthInfo(msg.data);
            }
          });
        } else {
          me.$message.error(res.data.message);
        }
      });
    },
    getQrcodeImage(code) {
      const me = this,
        url = me.$url.mobile + "/qrcode/login?code=" + code;
      me.$ajax({
        url: this.$url.api + "/api/commons/qrcode",
        method: "GET",
        responseType: "blob",
        params: {
          url,
          width: 188,
          height: 188,
        },
      }).then(function (res) {
        const blob = new Blob([res.data]);
        me.scanUrl = window.URL.createObjectURL(blob);
      });
    },
    addRefreshTask() {
      const me = this;
      me.refreshTask = setInterval(function () {
        if (Date.now() >= me.expireTime) {
          me.expired = true;
          me.scanned = false;
          me.clearRefreshTask();
        }
      }, 1000);
    },
    clearRefreshTask() {
      const me = this;
      if (me.refreshTask) {
        clearInterval(me.refreshTask);
      }
      disconnect();
    },
    /**
     * 授权成功后，通过该接口可以将身份信息写入sso cookie
     */
    refreshAuthInfo(authInfo) {
      const me = this;
      me.$ajax({
        url: this.$url.api + "/api/auth/switch/company?companyId=" + authInfo.companyId,
        method: "get",
        headers: {
          Authorization: authInfo.token.token
        }
      }).then(() => {
        me.$message.success("登录成功");
        me.$emit("login", authInfo);
      }).catch(err => {
        me.$message.error(err);
      });
    },
  },
};
</script>

<style>
.qrcode-box {
    position: relative;
}

.qrcode-info_wrap,
.qrcode-info_mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qrcode-info_wrap {
    z-index: 1;
}

.qrcode-info_mask {
  background: #fff;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

.qrcode-info {
  font-size: 12px;
  color: #222;
  text-align: center;
}

.qrcode-info_btn {
  border: 1px solid #aaa;
  border-radius: 2px;
  padding: 3px 6px;
  background: #f5f5f5;
  outline: 0;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/qrcode/login.vue